export const dateFormatFromBack = (date: string | null | undefined) => {
  if (!date) return '';
  return date.split('-').reverse().join('.');
};

export const dateFormatForBack = (date: string | null | undefined) => {
  if (!date) return '';
  return date.split('.').reverse().join('-');
};

export const formatDateTimeForDisplay = (dateString: string | null | undefined): string => {
  if (!dateString) return '—';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '—';
  }

  return date.toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
